import classnames from 'classnames'
import PropTypes from 'prop-types'
import { PureComponent } from 'react'

import { Avatar, IMAGE_SIZES, ImageSchema } from 'images'
import { Card, ProgressBar, SimpleButton } from 'ui'
import { ChildrenSchema } from 'utils'

import styles from './index.css'

const renderUnlocked = () => <div className={styles.corner}>🗝</div>

class EntityCard extends PureComponent {
  renderChildren = () => <div className={styles.body}>{this.props.children}</div>

  renderProgress = () => (
    <ProgressBar alert={this.props.progressAlert} className={styles.progress} value={this.props.progress} />
  )

  render() {
    const {
      children,
      className,
      elevation,
      fallbackIconName,
      image,
      onSubjectClick,
      progress,
      progressAlert,
      subtitle,
      title,
      unlocked,
      ...props
    } = this.props

    return (
      <Card
        className={classnames(className, styles.card, progress !== null && styles.withProgress)}
        elevation={elevation}
        {...props}
      >
        <div className={styles.image}>
          <Avatar
            fallbackIconName={fallbackIconName}
            onClick={onSubjectClick}
            size="4em"
            src={image}
            srcImageSize={IMAGE_SIZES.FIT_100_100}
          />
        </div>
        <div className={styles.content}>
          <div className={styles.title}>
            <SimpleButton className={styles.titleButton} onClick={onSubjectClick}>
              <span>
                {title}
                {!!subtitle && <div className={styles.subtitle}>{subtitle}</div>}
              </span>
            </SimpleButton>
          </div>
          {!!children && this.renderChildren()}
        </div>
        {unlocked && renderUnlocked()}
        {progress !== null && this.renderProgress()}
      </Card>
    )
  }
}

EntityCard.propTypes = {
  title: ChildrenSchema.isRequired,

  children: ChildrenSchema,
  className: PropTypes.string,
  elevation: PropTypes.number,
  fallbackIconName: PropTypes.string,
  image: ImageSchema,
  onSubjectClick: PropTypes.func,
  progress: PropTypes.number,
  progressAlert: PropTypes.bool,
  subtitle: ChildrenSchema,
  unlocked: PropTypes.bool,
}

EntityCard.defaultProps = {
  children: null,
  className: '',
  elevation: 1,
  fallbackIconName: 'image outline',
  image: null,
  onSubjectClick: Function.prototype,
  progress: null,
  progressAlert: false,
  subtitle: '',
  unlocked: false,
}

export default EntityCard
